/** Roomie sits in the corner of every page. The Office is its own 3D scene, so it stays off that route. */
export function showRoomie(pathname: string): boolean {
  return !pathname.startsWith("/office");
}
